import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles({
    root: {
        // background: 'rgb(218,68,83)',
        color: '#fff',
        outline:0,
        background: 'linear-gradient(101deg, rgba(218,68,83,1) 0%, rgba(237,85,101,1) 100%)',
        borderRadius: 37,
        padding: '2% 15%',
        textTransform: 'uppercase',
        '&.MuiButton-contained':{
            outline:'none'
        },
        '& .MuiTouchRipple-root span': {
            backgroundColor: 'transparent!important',
            color: '#fff',
            // opacity: 0.3,
          },
        '@media only screen and (max-width: 959px)': {
            marginBottom:'5vh',
            display:'flex',
            justifyContent:'center',
            padding: '1% 10%',
            // maxWidth: "62%",
          },
          '@media only screen and (max-width: 575px)': {
            marginBottom:'5vh',
            display:'flex',
            justifyContent:'center',
           
            // maxWidth: "62%",
          },
          '&:hover': {
            color: '#fff',
          },
    },
    black: {
        backgroundColor: '#525252',
        outline:'none',
    },
    
});

function ButtonMain(props: any) {
    const classes = useStyles();
    return(
        <Button variant="contained" href={props.link} className={clsx(classes.root, props.black?classes.black : '')}>{props.children}</Button>
    );
}
export default ButtonMain;
